/**
 * @file PrivacyPolicy.jsx
 * @description Privacy policy page with Material Design 3 styling
 */

import React from "react";
import { Icon } from "./Icon";
import { useViewportHeight } from "../utils/viewportUtils";

export const PrivacyPolicy = () => {
  const viewportHeight = useViewportHeight();
  return (
    <div style={{
      height: `calc(${viewportHeight} - 64px)`,
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Header */}
      <div style={{ 
        textAlign: 'center', 
        padding: '24px 16px 0 16px',
        flexShrink: 0
      }}>
        <h1 style={{ 
          fontSize: 'var(--md-sys-typescale-headline-large-size)',
          fontWeight: 'var(--md-sys-typescale-headline-large-weight)',
          color: 'var(--md-sys-color-on-surface)',
          margin: '0'
        }}>
          Privacy Policy
        </h1>
      </div>

      {/* Scrollable Content */}
      <div style={{
        flex: 1,
        overflow: 'auto',
        minHeight: 0,
        padding: '24px 16px'
      }}>
        <div className="container" style={{ maxWidth: '800px', margin: '0 auto' }}>
          {/* Content */}
          <div style={{
            backgroundColor: 'var(--md-sys-color-surface-container-low)',
            borderRadius: '16px',
            padding: '24px',
            marginBottom: '24px'
          }}>
            <h2 style={{
              fontSize: 'var(--md-sys-typescale-headline-medium-size)',
              fontWeight: 'var(--md-sys-typescale-headline-medium-weight)',
              color: 'var(--md-sys-color-on-surface)',
              marginBottom: '16px',
              marginTop: '0'
            }}>
              What data do we collect?
            </h2>
            <p style={{ marginBottom: '24px', lineHeight: '1.6' }}>
              memorize.life stores the data you provide when you create an
              account and use the site. This data includes your email address,
              password, name as provided by your login method, and reading
              challenge progress.
            </p>

            <h2 style={{
              fontSize: 'var(--md-sys-typescale-headline-medium-size)',
              fontWeight: 'var(--md-sys-typescale-headline-medium-weight)',
              color: 'var(--md-sys-color-on-surface)',
              marginBottom: '16px',
              marginTop: '32px'
            }}>
              How do we use your data?
            </h2>
            <p style={{ marginBottom: '16px', lineHeight: '1.6' }}>
              We do not share any personal data with anyone besides what is
              visible in the group reading features, and we do not use it for
              any purpose other than to provide you with the services on this
              site.
            </p>
            <p style={{ marginBottom: '16px', lineHeight: '1.6' }}>
              We will never sell your data to anyone or any entity, for any
              reason.
            </p>
            <p style={{ marginBottom: '24px', lineHeight: '1.6' }}>
              If you would like to change your displayed name, you can do so
              on the{" "}
              <a 
                href="/settings"
                style={{ 
                  color: 'var(--md-sys-color-primary)',
                  textDecoration: 'none'
                }}
              >
                settings page
              </a>.
            </p>

            <h2 style={{
              fontSize: 'var(--md-sys-typescale-headline-medium-size)',
              fontWeight: 'var(--md-sys-typescale-headline-medium-weight)',
              color: 'var(--md-sys-color-on-surface)',
              marginBottom: '16px',
              marginTop: '32px'
            }}>
              How can you request a copy of your data?
            </h2>
            <p style={{ marginBottom: '24px', lineHeight: '1.6' }}>
              Go to the{" "}
              <a 
                href="/data-request"
                style={{ 
                  color: 'var(--md-sys-color-primary)',
                  textDecoration: 'none'
                }}
              >
                data request page
              </a>{" "}
              and follow the instructions to request a copy of your data, or
              request that your data be deleted.
            </p>

            <h2 style={{
              fontSize: 'var(--md-sys-typescale-headline-medium-size)',
              fontWeight: 'var(--md-sys-typescale-headline-medium-weight)',
              color: 'var(--md-sys-color-on-surface)',
              marginBottom: '16px',
              marginTop: '32px'
            }}>
              How can you contact us?
            </h2>
            <p style={{ marginBottom: '0', lineHeight: '1.6' }}>
              If you have any questions about memorize.life's privacy policy,
              the data we store, or if you would like to exercise one of your
              data protection rights, please do not hesitate to contact us at{" "}
              <a 
                href="mailto:mail@memorize.life"
                style={{ 
                  color: 'var(--md-sys-color-primary)',
                  textDecoration: 'none'
                }}
              >
                mail@memorize.life
              </a>.
            </p>
          </div>

          {/* Back to Home */}
          <div style={{ textAlign: 'center', marginTop: '32px', marginBottom: '32px' }}>
            <md-filled-button href="/">
              <Icon name="home" slot="icon" />
              Back to Home
            </md-filled-button>
          </div>
        </div>
      </div>
    </div>
  );
};
